import React from 'react'
import { GENEMO_OPERATOR } from '../../../family-design/apps'

/**
 * 画面の一番下の共通フッター（family-design: gm-footer）。運営者・利用規約・プライバシーポリシー・特商法。
 * 文言は apps.ts の GENEMO_OPERATOR から出す。リンク先は Short の公開ページ（/terms は未ログインでも読める規約本文。
 * /terms-of-use は同意状況を見る要ログイン画面なので使わない）。
 */
const LINKS = [
  { label: '利用規約', href: '/terms' },
  { label: 'プライバシーポリシー', href: '/privacy' },
  { label: '特定商取引法に基づく表記', href: '/legal/specified-commercial' },
]

/** bottomInset: 画面下に固定の操作バーがある画面で、バーの高さ(px)を足してフッターが裏に隠れないようにする */
export const GenemoFooter: React.FC<{ bottomInset?: number }> = ({ bottomInset = 0 }) => (
  <footer className="gm-footer" style={bottomInset ? { paddingBottom: `calc(28px + ${bottomInset}px)` } : undefined}>
    <span>運営: {GENEMO_OPERATOR}</span>
    {LINKS.map(l => (
      <a key={l.href} href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>
    ))}
  </footer>
)

export default GenemoFooter
